import React, { useState } from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { FaInstagram, FaLinkedin, FaLink, FaYoutube } from 'react-icons/fa';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({ text: 'Enviar Mensagem', style: '' });

  const [ref1, isVisible1] = useIntersectionObserver();
  const [ref2, isVisible2] = useIntersectionObserver();
  const [ref3, isVisible3] = useIntersectionObserver();
  const [ref4, isVisible4] = useIntersectionObserver();
  const [ref5, isVisible5] = useIntersectionObserver();
  const [ref6, isVisible6] = useIntersectionObserver();
  const [ref7, isVisible7] = useIntersectionObserver();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validação básica
    const isValid = Object.values(formData).every(value => value.trim() !== '');

    if (!isValid) {
      setFormStatus({
        text: '⚠ Preencha todos os campos',
        style: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
      });

      setTimeout(() => {
        setFormStatus({ text: 'Enviar Mensagem', style: '' });
      }, 2000);
      return;
    }

    // Mostrar estado de carregamento
    setFormStatus({
      text: 'Enviando...',
      style: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
    });

    try {
      // Configurações do EmailJS
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      // Validar se as variáveis de ambiente estão configuradas
      if (!serviceId || !templateId || !publicKey) {
        console.error('Variáveis de ambiente não configuradas:', {
          serviceId: serviceId ? 'OK' : 'FALTANDO',
          templateId: templateId ? 'OK' : 'FALTANDO',
          publicKey: publicKey ? 'OK' : 'FALTANDO'
        });
        throw new Error('Configuração do EmailJS incompleta. Verifique o arquivo .env');
      }

      // Preparar dados do template
      const templateParams = {
        name: formData.name, // Para compatibilidade com {{name}}
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        message: formData.message,
        to_email: 'contato@alphatechai.com.br'
      };

      console.log('Enviando email com:', {
        serviceId,
        templateId,
        templateParams
      });

      // Enviar email
      const response = await emailjs.send(serviceId, templateId, templateParams, publicKey);

      console.log('Email enviado com sucesso:', response);

      // Sucesso
      setFormStatus({
        text: '✓ Mensagem Enviada!',
        style: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
      });

      // Reset form
      setTimeout(() => {
        setFormData({ name: '', email: '', phone: '', message: '' });
        setFormStatus({ text: 'Enviar Mensagem', style: '' });
      }, 3000);

    } catch (error) {
      console.error('Erro detalhado ao enviar email:', {
        error,
        status: error?.status,
        text: error?.text,
        message: error?.message
      });

      // Mensagem de erro mais específica
      let errorMessage = '⚠ Erro ao enviar. Tente novamente.';

      if (error?.status === 400) {
        errorMessage = '⚠ Erro: Verifique as configurações do EmailJS';
      } else if (error?.status === 401) {
        errorMessage = '⚠ Erro: Public Key inválida';
      } else if (error?.status === 404) {
        errorMessage = '⚠ Erro: Service ou Template não encontrado';
      }

      setFormStatus({
        text: errorMessage,
        style: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
      });

      setTimeout(() => {
        setFormStatus({ text: 'Enviar Mensagem', style: '' });
      }, 3000);
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Fale Conosco</span>
          <h2 className="section-title">
            Vamos <span className="gradient-text">conversar</span>?
          </h2>
          <p style={{
            color: 'var(--text-secondary)',
            maxWidth: '600px',
            margin: '0 auto',
            fontSize: '1.1rem'
          }}>
            Estamos prontos para transformar suas ideias em realidade. Entre em contato e descubra como podemos ajudar.
          </p>
        </div>
        <div className="contact-grid">
          <div className="contact-info">
            <div className={`contact-item ${isVisible1 ? 'scroll-animate in-view' : 'scroll-animate'}`} ref={ref1}>
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="contact-details">
                <h4>Localização</h4>
                <p>
                  Av. Joaquim Mochel, 66 – sala 01<br />
                  Cohatrac IV, São Luís – MA<br />
                  CEP: 65054-415, Brasil
                </p>
              </div>
            </div>
            <div className={`contact-item ${isVisible2 ? 'scroll-animate in-view' : 'scroll-animate'}`} ref={ref2}>
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.27099 2.11999 4.18C2.095 3.90347 2.12787 3.62476 2.21649 3.36162C2.30512 3.09849 2.44756 2.85669 2.63476 2.65162C2.82196 2.44655 3.0498 2.28271 3.30379 2.17052C3.55777 2.05833 3.83233 2.00026 4.10999 2H7.10999C7.5953 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04207 3.23945 9.10999 3.72C9.23662 4.68007 9.47144 5.62273 9.80999 6.53C9.94454 6.88792 9.97366 7.27691 9.8939 7.65088C9.81415 8.02485 9.62886 8.36811 9.35999 8.64L8.08999 9.91C9.51355 12.4135 11.5864 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="contact-details">
                <h4>Telefone</h4>
                <p>+55 (98) 98776-0897</p>
              </div>
            </div>
            <div className={`contact-item ${isVisible3 ? 'scroll-animate in-view' : 'scroll-animate'}`} ref={ref3}>
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M3 7L12 13L21 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="contact-details">
                <h4>E-mail</h4>
                <p>contato@alphatechai.com.br</p>
              </div>
            </div>
            <div className="social-buttons">
              <a
                href="https://www.instagram.com/ia.alphatech?igsh=c3U0ZnoydWZqYnly&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className={`contact-item social-item ${isVisible4 ? 'scroll-animate in-view' : 'scroll-animate'}`}
                ref={ref4}
                aria-label="Instagram"
              >
                <div className="contact-icon social-icon">
                  <FaInstagram />
                </div>
              </a>
              <div
                className={`contact-item social-item ${isVisible5 ? 'scroll-animate in-view' : 'scroll-animate'}`}
                ref={ref5}
                aria-label="LinkedIn"
              >
                <div className="contact-icon social-icon">
                  <FaLinkedin />
                </div>
              </div>
              <div
                className={`contact-item social-item ${isVisible7 ? 'scroll-animate in-view' : 'scroll-animate'}`}
                ref={ref7}
                aria-label="YouTube"
              >
                <div className="contact-icon social-icon">
                  <FaYoutube />
                </div>
              </div>
              <div
                className={`contact-item social-item ${isVisible6 ? 'scroll-animate in-view' : 'scroll-animate'}`}
                ref={ref6}
                aria-label="Linktree"
              >
                <div className="contact-icon social-icon">
                  <FaLink />
                </div>
              </div>
            </div>
          </div>
          <div className="contact-form-wrapper">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nome</label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Seu nome completo"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">E-mail</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="seu@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Telefone</label>
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  placeholder="(00) 00000-0000"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Mensagem</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Como podemos ajudar você?"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="btn-primary btn-large btn-full"
                style={formStatus.style ? { background: formStatus.style } : {}}
              >
                {formStatus.text}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;